export default "__VITE_ASSET__ddcebecf__"